export const entityProjectionNames = {
  Ticket: 'tickets',
  Finding: 'uber_findings',
  Asset: 'uber_assets',
  Incident: 'incidents',
  Alert: 'uber_alerts',
  PolicyViolation: 'uber_policy_violations',
  Exception: 'uber_exceptions',
  ViolationTicket: 'violation_tickets',
  IdentityFinding: 'uber_identity_findings',
  User: 'uber_users',
  Identity: 'uber_identities',
  Tenant: 'uber_tenants',
  GlobalVulnerability: 'uber_global_vulnerabilities',
  Group: 'uber_security_groups',
} as const;

export type EntityProjectionName = (typeof entityProjectionNames)[keyof typeof entityProjectionNames];
